module.exports = __webpack_public_path__ + "static/3-81a1215c23f151a0f24e7a7b5ebd59bf.jpg";